export const mappingToForm = (mapping) =>
  Object.entries(mapping.mapping).map(([name, mapping]) => ({
    name,
    mapping: {
      operation: mapping.operation,
      default_value: mapping.default_value,
      target1: mapping.targets[0] || '',
      target2: mapping.targets[1] || '',
      separator: mapping.options.separator,
      index: mapping.options.index,
    },
  }));
